import { LooseObject } from "../models/loose-object.model";

export default class FormatUtil {

    static supToUnicode(input: string): string {
        var SUPERSCRIPTS: LooseObject = {
            ' ': ' ',
            '0': '⁰',
            '1': '¹',
            '2': '²',
            '3': '³',
            '4': '⁴',
            '5': '⁵',
            '6': '⁶',
            '7': '⁷',
            '8': '⁸',
            '9': '⁹',
            '+': '⁺',
            '-': '⁻',
            '=': '⁼',
            '(': '⁽',
            ')': '⁾',
            'a': 'ᵃ',
            'b': 'ᵇ',
            'c': 'ᶜ',
            'd': 'ᵈ',
            'e': 'ᵉ',
            'f': 'ᶠ',
            'g': 'ᵍ',
            'h': 'ʰ',
            'i': 'ⁱ',
            'j': 'ʲ',
            'k': 'ᵏ',
            'l': 'ˡ',
            'm': 'ᵐ',
            'n': 'ⁿ',
            'o': 'ᵒ',
            'p': 'ᵖ',
            'r': 'ʳ',
            's': 'ˢ',
            't': 'ᵗ',
            'u': 'ᵘ',
            'v': 'ᵛ',
            'w': 'ʷ',
            'x': 'ˣ',
            'y': 'ʸ',
            'z': 'ᶻ',
            'A': 'ᴬ',
            'B': 'ᴮ',
            'D': 'ᴰ',
            'E': 'ᴱ',
            'G': 'ᴳ',
            'H': 'ᴴ',
            'I': 'ᴵ',
            'J': 'ᴶ',
            'K': 'ᴷ',
            'L': 'ᴸ',
            'M': 'ᴹ',
            'N': 'ᴺ',
            'O': 'ᴼ',
            'P': 'ᴾ',
            'R': 'ᴿ',
            'T': 'ᵀ',
            'U': 'ᵁ',
            'V': 'ⱽ',
            'W': 'ᵂ',
            'α': 'ᵅ',
            'β': 'ᵝ',
            'γ': 'ᵞ',
            'δ': 'ᵟ',
            'ε': 'ᵋ',
            'θ': 'ᶿ',
            'ι': 'ᶥ',
            'Φ': 'ᶲ',
            'ϕ': 'ᵠ',
            'χ': 'ᵡ'
        };

        return input.replaceAll(/(?<=\<sup>)(.|\n)*?(?=\<\/sup>)/g, function (match) {
            return match.split('').map(function (c) {
                if (c in SUPERSCRIPTS) {
                    return SUPERSCRIPTS[c]
                }
                return ''
            }).join('')
        }).replaceAll('<sup>', '').replaceAll('</sup>', '');
    }

    static subToUnicode(input: string): string {
        var SUBSCRIPTS: LooseObject = {
            ' ': ' ',
            '0': '₀',
            '1': '₁',
            '2': '₂',
            '3': '₃',
            '4': '₄',
            '5': '₅',
            '6': '₆',
            '7': '₇',
            '8': '₈',
            '9': '₉',
            '+': '₊',
            '-': '₋',
            '=': '₌',
            '(': '₍',
            ')': '₎',
            'a': 'ₐ',
            'e': 'ₑ',
            'h': 'ₕ',
            'i': 'ᵢ',
            'j': 'ⱼ',
            'k': 'ₖ',
            'l': 'ₗ',
            'm': 'ₘ',
            'n': 'ₙ',
            'o': 'ₒ',
            'p': 'ₚ',
            'r': 'ᵣ',
            's': 'ₛ',
            't': 'ₜ',
            'u': 'ᵤ',
            'v': 'ᵥ',
            'x': 'ₓ',
            'β': 'ᵦ',
            'γ': 'ᵧ',
            'ρ': 'ᵨ',
            'ϕ': 'ᵩ',
            'χ': 'ᵪ'
        };

        return input.replaceAll(/(?<=\<sub>)(.|\n)*?(?=\<\/sub>)/g, function (match) {
            return match.split('').map(function (c) {
                if (c in SUBSCRIPTS) {
                    return SUBSCRIPTS[c]
                }
                return ''
            }).join('')
        }).replaceAll('<sub>', '').replaceAll('</sub>', '');
    }

    static removeSupTags(input: string): string {
        return input.replaceAll('<sup>', '').replaceAll('</sup>', '');
    }

    static removeSubTags(input: string): string {
        return input.replaceAll('<sub>', '').replaceAll('</sub>', '');
    }

    static removeSubSupTags(input: string): string {
        return this.removeSubTags(this.removeSupTags(input));
    }

  /**
   * removes tags added to scenario titles for tree table styling
   * @param input node input string
   */
    static removeScenarioTags(input: string): string {
      const scenarioTag = '<p-for-scenario>';
      const closingTag = '</p>';
      return input.replaceAll(scenarioTag, '').replaceAll(closingTag, '');
    }
}
